import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {
  private backendUrl = environment.backendEndpoint;

  constructor(private http: HttpClient) {}

  subscribeToBlog(body: any): Observable<any> {
    return this.http.post(`${this.backendUrl}/subscribe/subscribeToBlog`, body);
  }
}
